export default __webpack_public_path__ + "1949222de4a788265911cd22330fb2c4.jpg";